import RecentDocuments from './RecentDocuments';

export default RecentDocuments;
